import React, { FunctionComponent } from "react";

import { ISectionProps, Section, Shadow, TStyleSize } from "@/eworkitComponents";

export interface ICardProps extends ISectionProps {
  shadowSize?: TStyleSize;
  className?: string;
}

export const Card: FunctionComponent<ICardProps> = ({ children, shadowSize = "sm", className, ...sectionProps }) => (
  <Shadow size={shadowSize}>
    <Section
      borderRadius
      background="secondary"
      padding={[true]}
      border={[true]}
      {...sectionProps}
      className={className}>
      {children}
    </Section>
  </Shadow>
);
